import ActionButton from 'components/ActionButton';
import React, { useState } from 'react';
import { DATE_FORMATS, DISCOUNT_TYPES, showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import DropDown from 'components/FormFields/dropdown';
import { createDiscount } from 'services/api/discounts';
import moment from 'moment';
import DecimalInput from 'components/DecimalInput';
import WholeNumberInput from 'components/WholeNumberInput';
import DatePicker from 'react-datepicker';
import ActionCheckbox from 'components/ActionCheckBox';

const CreateDiscount = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [active, setActive] = useState<boolean>(true);
  const [type, setType] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [startDate, setStartDate] = useState<string>(moment().toISOString());
  const [endDate, setEndDate] = useState<string>(moment().toISOString());
  const [discountPercent, setDiscountPercent] = useState<number>(0);
  const [discountAmount, setDiscountAmount] = useState<number>(0);

  const createDiscountFn = async () => {
    setLoading(true);
    try {
      if (!type) {
        throw 'type is required';
      }
      if (!code) {
        throw 'code is required';
      }
      const discountDetails = {
        code,
        type,
        startDate,
        endDate,
        active,
        discountAmount,
        discountPercent,
      };
      const res = await createDiscount(discountDetails);
      showSuccess('Discount added successfully.');
      props.history.replace(`/discounts/${res.id}`);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const getPercentOrAmount = () => {
    if (type.includes('FIXED')) {
      return (
        <div className='ml-3'>
          <div className={styles['info']}>
            <div className={styles['label']}>Discount Amount</div>
            <WholeNumberInput
              value={discountAmount}
              disabled={loading}
              onChange={e => setDiscountAmount(e)}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className='ml-3'>
          <div className={styles['info']}>
            <div className={styles['label']}>Discount Percent</div>
            <DecimalInput
              value={discountPercent}
              disabled={loading}
              onChange={e => setDiscountPercent(e)}
            />
          </div>
        </div>);
    }
  };

  const getDates = () => (
    <div className='d-flex'>
      <div className={styles['info']}>
        <div className={styles['label']}>Start Date</div>
        <div className={styles['date-picker']}>
          <DatePicker
            className={'form-control'}
            showTimeInput
            dateFormat={DATE_FORMATS.MM_dd_yyyy__EE_hh_mm_a}
            selected={startDate ? moment(startDate).toDate() : null}
            onChange={(e: any) => setStartDate(moment(e).toISOString())}
          />
        </div>
      </div>
      <div className={styles['info']}>
        <div className={styles['label']}>End Date</div>
        <div className={styles['date-picker']}>
          <DatePicker
            className={'form-control'}
            dateFormat={DATE_FORMATS.MM_dd_yyyy__EE_hh_mm_a}
            showTimeInput
            selected={endDate ? moment(endDate).toDate() : null}
            onChange={(e: any) => setEndDate(moment(e).toISOString())}
          />
        </div>
      </div>
    </div>
  );

  const getFooter = () => (
    <div className={styles['footer']}>
      <ActionButton
        text={'Cancel'}
        active={!loading}
        isLoading={false}
        onClick={() => props.history.goBack()}
        customClass={styles['cancel']}
      />
      <ActionButton
        text={'Create Discount'}
        active={!loading}
        isLoading={loading}
        onClick={createDiscountFn}
      />
    </div>
  );

  const getActiveContainer = () => (
    <div className={styles['info']}>
      <div className={styles['label']}>Active</div>
      <div className={styles['active-input-container']}>
        <ActionCheckbox
          checked={active}
          disabled={loading}
          onChange={() => setActive(!active)}
        />
      </div>
    </div>
  );

  const getBody = () => (
    <div className={styles['account-details']}>
      <div className={styles['info']}>
        <div className={styles['label']}>Discount Code</div>
        <input
          onChange={(e) => setCode(e.target.value)}
          className={'form-control'}
          disabled={loading}
        />
      </div>
      <div className='d-flex'>
        <div className={styles['info']}>
          <div className={styles['label']}>Discount Type</div>
          <DropDown value={type} onChange={(e) => setType(e)} options={DISCOUNT_TYPES} containerClass={'form-select'} />
        </div>
        {getPercentOrAmount()}
      </div>
      {getDates()}
      {getActiveContainer()}
    </div>
  );

  const getHeader = () => (
    <div className={styles['header']}>
      <div className={styles['heading']}>Create a New Discount</div>
    </div>
  );

  return (
    <div className={styles['main-container']}>
      {getHeader()}
      {getBody()}
      {getFooter()}
    </div>
  );
};

export { CreateDiscount };
